module.exports = __webpack_public_path__ + "static/bootstrapping-7c404998a39ff3720316afbc0ab60c36.png";